import { render, staticRenderFns } from "./yl.vue?vue&type=template&id=0b3b5baf&scoped=true&"
import script from "./yl.vue?vue&type=script&lang=js&"
export * from "./yl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b5baf",
  null
  
)

export default component.exports